import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { getTimezoneManager, getSortedTimezoneList } from '@nextcloud/calendar-js';
let TimezoneService = class TimezoneService {
    timezoneManager = getTimezoneManager();
    sortedTimezones = [];
    constructor() {
        this.timezoneManager.registerDefaultTimezones();
        this.initializeTimezones();
    }
    initializeTimezones() {
        this.sortedTimezones = getSortedTimezoneList(this.timezoneManager.listAllTimezones());
    }
    getTimezoneById(timezoneId) {
        return this.timezoneManager.getTimezoneForId(timezoneId);
    }
    getSortedTimezones() {
        return this.sortedTimezones;
    }
    getTimezoneManager() {
        return this.timezoneManager;
    }
    getLocalTimezoneOrUTC() {
        const localTimezoneId = new Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.getTimezoneOrUTC(localTimezoneId);
    }
    getTimezoneOrUTC(timezoneId) {
        return this.getTimezoneById(timezoneId) || this.getTimezoneManager().getTimezoneForId('UTC');
    }
    static ctorParameters = () => [];
};
TimezoneService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], TimezoneService);
export { TimezoneService };
